module.exports = __webpack_public_path__ + "static/company-thumbnail-a9a49c8770393c124a8e1bdbf453d1bc.png";